import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './Blog.css';

function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await axios.get('https://api.chekidesara.ir/api/blog/posts');
      setPosts(response.data.data);
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">در حال بارگذاری مقالات...</div>;

  return (
    <div className="blog-page">
      <div className="container">
        <h1>📝 مقالات چکیده‌سرا</h1>
        <p className="blog-subtitle">
          نکات کلیدی برای مطالعه کتاب‌های انگلیسی، تقویت زبان و موفقیت در آزمون‌های بین‌المللی
        </p>

        <div className="blog-grid">
          {posts.map((post) => (
            <article key={post._id} className="blog-card">
              {post.image && <img src={post.image} alt={post.title} className="blog-image" />}
              <div className="blog-card-content">
                <h2>
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h2>
                <div className="blog-meta">
                  <span>📅 {new Date(post.publishedAt).toLocaleDateString('fa-IR')}</span>
                  <span>⏱️ {post.readTime} دقیقه مطالعه</span>
                </div>
                <p>{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`} className="read-more">
                  ادامه مطلب →
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Blog;